import React from "react";
import Grid from "@mui/material/Grid";
import {
  Avatar,
  Box,
  Container,
  IconButton,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import LogoSection from "../LogoSection";
import { Facebook, ForwardToInboxOutlined, Instagram, LinkedIn, WhatsApp } from "@mui/icons-material";

const Footer = () => {
  const theme = useTheme();
  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          pt: 4,
          // bgcolor: theme.palette.secondary.dark,
          background: `linear-gradient(120deg, transparent 0%, ${theme.palette.secondary.dark} 100%)`,
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={4}
            alignItems={"center"}
          >
            <Grid size={{ xs: 12, sm: 8, md: 7 }}>
              <Box
                display="flex"
                alignItems="flex-start"
                flexDirection="column"
                gap={1}
              >
                <LogoSection />

                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ letterSpacing: "0.5px", lineHeight: "1.5" }}
                >
                  Freecomers is a data driven film festival intelligence and networking platform that helps filmmakers discover the right festivals, optimize their submission strategy and connect with the global film ecosystem while enabling film lovers to engage with curated, high quality cinema.
                </Typography>

                {/* Social Media Links */}
                <Box sx={{ display: "flex", gap: 1 }}>

                  <IconButton
                    onClick={() =>
                      window.open(
                        "https://www.facebook.com/people/Freecomers/61572890274779/",
                        "_blank"
                      )
                    }
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      "&:hover": { backgroundColor: theme.palette.background.paper },
                    }}
                  >
                    <Facebook sx={{ fontSize: 20, color: "primary.dark" }} />
                  </IconButton>

                  <IconButton
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/freecomers?igsh=NDFwMGNka2JtNTN5&utm_source=qr",
                        "_blank"
                      )
                    }
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      "&:hover": { backgroundColor: theme.palette.background.paper },
                    }}
                  >
                    <Instagram sx={{ fontSize: 20, color: "primary.dark" }} />
                  </IconButton>

                  <IconButton
                    onClick={() =>
                      window.open(
                        "https://www.linkedin.com/company/freecomers-filmworks/",
                        "_blank"
                      )
                    }
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      "&:hover": { backgroundColor: theme.palette.background.paper },
                    }}

                  >

                    <LinkedIn sx={{ fontSize: 20, color: "primary.dark" }} />

                  </IconButton>

                  <IconButton
                    onClick={() =>
                      window.open(
                        "https://wa.me/919764900063?text=Hello%20Freecomers!%20I%20would%20like%20to%20know%20more%20about%20your%20services.",
                        "_blank"
                      )
                    }
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      "&:hover": { backgroundColor: theme.palette.background.paper },
                    }}

                  >
                    <WhatsApp sx={{ fontSize: 20, color: "primary.dark" }} />
                  </IconButton>

                  <IconButton
                    onClick={() =>
                      window.open(
                        "mailto:info@freecomers.com",
                        "_blank"
                      )
                    }
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      "&:hover": { backgroundColor: theme.palette.background.paper },
                    }}

                  >
                    <ForwardToInboxOutlined sx={{ fontSize: 20, color: "primary.dark" }} />
                  </IconButton>

                </Box>

              </Box>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, md: 2 }}>
              <Typography variant="h6" gutterBottom fontWeight={600}>
                Help
              </Typography>
              <Link
                sx={{ textDecoration: "none" }}
                href="/faq"
                variant="body2"
                color="inherit"
                display="block"
                mb={1}
              >
                FAQ
              </Link>
              <Link
                sx={{ textDecoration: "none" }}
                href="/contact"
                variant="body2"
                color="inherit"
                display="block"
                mb={1}
              >
                Contact us
              </Link>
              <Link
                sx={{ textDecoration: "none" }}
                href="/about"
                variant="body2"
                color="inherit"
                display="block"
                mb={1}
              >
                About us
              </Link>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <Typography variant="h6" gutterBottom fontWeight={600}>
                Legal page
              </Typography>
              <Link
                sx={{ textDecoration: "none" }}
                href="/terms-and-conditions"
                variant="body2"
                color="inherit"
                display="block"
                mb={1}
              >
                Terms & Conditions
              </Link>
              <Link
                sx={{ textDecoration: "none" }}
                href="/privacy-policy"
                variant="body2"
                color="inherit"
                display="block"
                mb={1}
              >
                Privacy Policy
              </Link>
              <Link
                sx={{ textDecoration: "none" }}
                href="/disclaimer"
                variant="body2"
                color="inherit"
                display="block"
                mb={1}
              >
                Disclaimer
              </Link>
            </Grid>
          </Grid>
        </Container>
        <Box textAlign="center" sx={{ py: 2 }}>
          <Typography variant="body2" gutterBottom>
            © {new Date().getFullYear()} <b>Freecomers Filmtech Pvt Ltd.</b> | All Rights Reserved.
          </Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Footer;
